<template>
  <x-modal size="large" @overlay-clicked="close">
    <div class="x-modal__contents">
      <x-heading size="3" data-test="paywall-modal-title">
        {{ title }}
      </x-heading>
      <x-body-text size="1" class="subtext" data-test="paywall-modal-subtext">
        {{ text }}
      </x-body-text>
      <div class="buttons">
        <ys-button
          variant="primary"
          size="medium"
          class="create-acct-btn"
          data-test="paywall-modal-upgrade-button"
          @click="createAccount"
        >
          {{ upgradeLabel }}
        </ys-button>
        <ys-button
          variant="ghost"
          size="medium"
          data-test="paywall-modal-close-button"
          @click="close()"
        >
          Maybe Later
        </ys-button>
      </div>
    </div>
  </x-modal>
</template>
<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
import '@onxmaps/yellowstone-ui/ys-button'
import xModal from '@/components/shared/x-modal'
import xHeading from '@/components/shared/x-heading'
import xBodyText from '@/components/shared/x-body-text'

import { toTitleCase } from '@/lib/input-mod'
import pubsub from '@/lib/pubsub'

export default {
  components: {
    xModal,
    xHeading,
    xBodyText,
  },
  inject: {
    theme: { default: 'hunt' },
  },
  props: {
    type: {
      type: String,
      default: undefined,
    },
    upgradeLabel: {
      type: String,
      default: undefined,
    },
  },
  emits: ['close', 'create'],
  computed: {
    cta() {
      return this.type
    },
    app() {
      return 'fish'
    },
    appTitle() {
      return toTitleCase(this.app)
    },
    title() {
      return this.modalTitles[this.cta] || ''
    },
    text() {
      return this.modalText[this.cta] || ''
    },

    modalTitles() {
      // lifted from guest-signup-modal.vue
      return {
        landownerSearch: 'Search By Owner.',
        photoWp: 'Picture This.',
        offlineMap: 'Need Offline Maps?',
        shareMarkup: 'Share With Friends.',
        toggle3d: 'Access 3D Maps.',
        discoverThumbnail: 'Discover Local Recreation.',
        importButton: `Import Content into onX ${this.appTitle}.`,
        exportButton: `Export Content from onX ${this.appTitle}.`,
        trimTrack: 'Need to trim your tracks?',
        photoWaypoint: 'Photo Upload Unavailable',
      }
    },
    modalText() {
      // lifted from guest-signup-modal.vue
      // FUTURE - update these messages to upgrade rather than create account
      return {
        landownerSearch:
          'It’s even easier to find properties when you can search by name. Create an account to try it out.',
        photoWp:
          'You must have an account to add photo waypoints to the map. Create an account and start a trial to check it out today.',
        offlineMap:
          'If you would like to save offline maps, create an account and check it out today.',
        shareMarkup:
          'You must create an account with us before you can share content. Once you have an account, you can share away.',
        toggle3d:
          'You must have an account to access 3D maps. Create an account and start a trial to check it out today.',
        discoverThumbnail:
          'Learn about the best trails in your area. Create an account and start a trial to check it out today.',
        importButton: `onX ${this.appTitle} subscribers can import map data files and add waypoints, tracks, and other data from a GPS device, watch and more. Create an account to import content.`,
        exportButton: `onX ${this.appTitle} subscribers can export map data files that include waypoints, tracks, and photos. Create an account to export content.`,
        trimTrack:
          'Your membership doesn’t include track trimming. Please upgrade to a Premium or Elite membership to trim tracks ',
        photoWaypoint:
          'Your Basic Membership does not include photo uploads. Please upgrade your membership to unlock this feature.',
      }
    },
  },
  methods: {
    close() {
      pubsub.publish('close-paywall-popup')
      this.$emit('close')
    },
    createAccount() {
      pubsub.publish('create-paywall')
      this.$emit('create')
    },
  },
}
</script>
<style lang="scss" scoped>
@use '@/styles/system/_colors.scss';

.buttons {
  display: flex;
  flex-direction: column;
  gap: var(--ys-spacing-100);
}

.subtext {
  color: colors.$Grey70;
  padding-bottom: 35px;
}
.create-acct-btn {
  width: 100%;
  span {
    color: white;
  }
}
.maybe-later {
  cursor: pointer;
}
</style>
